import MainAdminInquiries from "../../components/admin-inquiries/main-admin-inquiries";

export default function AdminInquiriesPage() {
  return <MainAdminInquiries />;
}
